module.exports = __webpack_public_path__ + "static/media/bbc-weather-web.e4a9b05e.png";